
            const data = {"name":"vectorRight","data":{"width":"25","height":"26","viewBox":"0 0 25 26","data":"<path pid=\"0\" d=\"M10.013 6.682 8.74 7.954 13.786 13 8.74 18.046l1.273 1.272 5.045-5.045L16.262 13l-1.204-1.273-5.045-5.045Z\" _fill=\"#333\"/>","originalColors":[{"type":"fill","color":"#333"}],"stopColors":[]}}
        
                module.exports = data
                